"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _Dot = _interopRequireDefault(require("../Dot/Dot"));

var _useColor = _interopRequireDefault(require("../../hooks/useColor"));

var _ProgressBar = _interopRequireDefault(require("./ProgressBar"));

var _ProgressDots = require("./ProgressDots.styles");

var ProgressDots = function ProgressDots(_ref) {
  var className = _ref.className,
      count = _ref.count,
      now = _ref.now,
      size = _ref.size,
      dotColor = _ref.dotColor,
      activeColor = _ref.activeColor;
  var bgColor = (0, _useColor["default"])(dotColor);
  var activeBgColor = (0, _useColor["default"])(activeColor);
  return (0, _jsxRuntime.jsx)("div", {
    css: _ProgressDots.styles.base,
    className: className,
    children: (0, _toConsumableArray2["default"])(Array(count)).map(function (_, index) {
      return (// eslint-disable-next-line react/no-array-index-key
        (0, _jsxRuntime.jsx)("div", {
          css: _ProgressDots.styles.dotWrapper,
          children: (0, _jsxRuntime.jsx)(_Dot["default"], {
            size: size,
            color: index === now - 1 ? activeBgColor : bgColor,
            css: index === now - 1 && _ProgressDots.styles.active
          })
        }, index)
      );
    })
  });
};

ProgressDots.propTypes = {
  className: _propTypes.string,
  count: _propTypes.number,
  now: _propTypes.number,
  size: (0, _propTypes.oneOf)(['big', 'small']),
  dotColor: _propTypes.string,
  activeColor: _propTypes.string
};
ProgressDots.defaultProps = {
  className: undefined,
  count: 3,
  now: 1,
  size: 'small',
  dotColor: 'color.info.100',
  activeColor: 'color.primary.info'
};
ProgressDots.Bar = _ProgressBar["default"];
var _default = ProgressDots;
exports["default"] = _default;
//# sourceMappingURL=ProgressDots.js.map